// extracted by mini-css-extract-plugin
export default {"container":"SkusTable_container__3Tg9a"};